import React, { useContext, useEffect, useRef, useState } from "react";
import parser from "html-react-parser";
import "./PPMContent.scss";
import {
  GetcmsContent,
  PPM,
  MarkDocumentRead,
  RequestNextStage,
} from "../../utils/Api/api";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../utils/pageRoutes";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Link, Element } from "react-scroll";
import { InView } from "react-intersection-observer";
import "../../pages/InvestorCentrer/investorCenter.scss";
import { Context } from "../../contextApi/contextProvider";
import PpmPop from "../../utils/popMenu/PpmPop";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
interface Document {
  post_id: string;
  post_name: string;
  document_status: string;
}

interface Stage {
  stage_uid: string;
  stage_name: string;
  stage_status: string;
  stage_priority: string;
  documents?: Document[];
}
export const getDocumentSection = (
  stages: Stage[],
  stage_name: string,
): string | undefined => {
  return stages
    .find((stage) => stage.stage_name.trim() === stage_name)
    ?.stage_priority.trim();
};

const Intro = () => {
  const loaction = useGeoLocation();
  const navigator = useNavigate();
  const [htmlString, setHtmlStr] = useState([]);
  const [cmsContentString, setCMSContentString] = useState([]);
  const [ppmPop, setppmPop] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const rightSlideRef = useRef<HTMLDivElement>(null);
  const [indexSilde, setIndexSilde] = useState(0);
  const [apiLogin, setApiLogin] = useState(false);
  const token = JSON.parse(localStorage.getItem("access_token") as string);
  const [businessObject, setBusinessObject] = useState({
    status: 0,
    error_code: 7,
    message: "",
  });
  const [businessMenuToogle, setbusinessMenuToogle] = useState(false);

  const { userLoginData, setLoadingLoader, accessDoc, setAccessDoc } =
    useContext(Context);
  const resize = () => {
    if (containerRef.current && rightSlideRef.current) {
      const container = containerRef.current;
      const rightSlide = rightSlideRef.current;
      const scale = Math.min(
        document.documentElement.clientWidth / container.offsetWidth,
        document.documentElement.clientHeight / container.offsetHeight,
      );
      container.style.transform = `scale(${scale})`;
      container.style.transformOrigin = "top left";
      container.style.position = "absolute";
      container.style.top = `calc(${10}px)`;
      container.style.left = `calc(50% - ${
        (container.offsetWidth * scale) / 2
      }px)`;
      const scale1 = 0.18;

      rightSlide.style.transform = `scale(${scale1})})`;
      rightSlide.style.transformOrigin = "top left";
      // rightSlide.style.position = "absolute";
      rightSlide.style.top = `calc(50% - ${
        (rightSlide.offsetHeight * scale1) / 2
      }px)`;
      rightSlide.style.left = `calc(50% - 120px)`;
    }
  };

  const requestPPM = async () => {
    setApiLogin(true);
    try {
      const { data } = await RequestNextStage({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
        section_id: await getDocumentSection(
          accessDoc?.all_stage_info as Stage[],
          "Stage 1 - Business Insight",
        ),
      });
      if (data.status == 200) {
        setApiLogin(false);
        setppmPop(true);
        setAccessDoc({
          ...accessDoc,
          ["13678"]: "PENDING",
          ["9431"]: "PENDING",
          ["12879"]: "PENDING",
          ["13029"]: "PENDING",
        });
      }
    } catch (error) {
      setApiLogin(false);
    } finally {
      setApiLogin(false);
    }
  };
  function getDocumentStatus(postId: string): string {
    const value = accessDoc[postId];
    return typeof value === "string" ? value : ""; // or handle as needed
  }

  const accessBusinessSummary = async (htmlArray: string[]) => {
    try {
      const accessStatus = await getDocumentStatus("13678");

      setBusinessObject({
        status: 2,
        error_code: 7,
        message: accessStatus,
      });
      const dataFinal: any = htmlArray;
      if (dataFinal) {
        setHtmlStr(dataFinal);
      }
    } catch (error) {
      setBusinessObject({
        status: 2,
        error_code: 7,
        message: "Learn More About TICCA",
      });
      const dataFinal: any = await htmlArray;

      setHtmlStr(dataFinal);
    }
  };

  const handleContextMenu = (e: any) => {
    e.preventDefault(); // This should block the context menu
  };

  useEffect(() => {
    setCMSContentString(htmlString);
  }, [htmlString]);
  useEffect(() => {
    if (!token || !containerRef.current || !rightSlideRef.current) return;

    if (cmsContentString.length > 0) {
      setIndexSilde(0);
    }
  }, [cmsContentString]);

  useEffect(() => {
    resize();
    if (userLoginData.status == 200 && accessDoc["13678"] !== "de") {
      const fetchData = async (data: PPM) => {
        if (token) {
          try {
            const response1 = await GetcmsContent(data);

            const dataArray: any = response1.data?.content?.split(
              "<!--nextpage-->",
            ) as string[];
            accessBusinessSummary(dataArray);
          } catch (error) {
            console.error("Error fetching data from endpoint1:", error);
            navigator("/");
          } finally {
            setLoadingLoader(false);
          }
        }
      };

      const fetchIpAddress = async () => {
        try {
          setLoadingLoader(true);

          fetchData({
            post_id: "13672",
            ip_address: userLoginData.ip,
            form_lat: await loaction.coordinates.lat,
            form_lon: await loaction.coordinates.lng,
          });
        } catch (error) {}
      };
      fetchIpAddress();
    } else if (userLoginData.status == 404) {
      navigator(PageRoutes.home);
    } else if (token === "" || token === null || token === undefined) {
      navigator(PageRoutes.home);
    }

    document.title = "TICCA | Intro";
    window.scrollTo(0, 0);

    window.addEventListener("resize", resize);

    return () => window.removeEventListener("resize", resize);
  }, [userLoginData.status, accessDoc]);
  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "13678",
      });
    } catch (error) {}
  };
  useEffect(() => {
    if (userLoginData.status == 200) {
      readDoc();
    }
  }, [userLoginData.status]);
  return (
    <>
      <div className="">{ppmPop && <PpmPop setppmPop={setppmPop} />}</div>
          <div
            className={`bussiness-side-menu ${
              businessMenuToogle
                ? "left-side-animation"
                : "right-side-animation"
            }`}
          >
            <div
              onClick={() => {
                setbusinessMenuToogle(!businessMenuToogle);
              }}
              className="bussiness-side-div"
            >
              <div className="bussiness-left-arrow">
                <div className="bussiness-dev-list">
                  <img
                    src="https://public.ticca.com/images/svg/Right_Arrow.svg"
                    alt="arrow"
                  />
                </div>
                <div className="">
                  <img
                    style={{ width: "38px", height: "35px" }}
                    src="https://public.ticca.com/images/svg/MenuList.svg"
                    alt="menu"
                  />
                </div>
              </div>
            </div>
            <div className="bussiness-side-tatile-dev">
              <p>List of Content</p>
              <div
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  bottom: "20px",
                }}
                onClick={() => setbusinessMenuToogle(false)}
              >
                <samp>
                  <img
                    src="https://public.ticca.com/images/svg/InvestorMenuCloseArrow.svg"
                    alt="close"
                  />
                </samp>
              </div>
            </div>
            <div
              className="scroll-dev"
              style={{
                position: "relative",
                overflowX: "hidden",
                marginTop: "-10px",
                zIndex: "-1",
              }}
            >
              <div
                ref={rightSlideRef}
                onContextMenu={handleContextMenu}
                className="ex-su-maindiv-sub"
                style={{
                  scale: "0.18",
                  marginLeft: "40px",
                  marginBottom: "-120px",
                }}
                id="content-container"
              >
                {cmsContentString?.length > 1 ? (
                  cmsContentString?.map((elem: string, index: any) => (
                    <>
                      <Link to={`bs-${index}`} smooth={true} duration={500}>
                        <div
                          style={{
                            marginBottom: "100px",
                            cursor: "pointer",
                            borderRadius: "20PX",
                            border: `${
                              index == indexSilde
                                ? "15px solid rgba(71, 144, 255, 1)"
                                : "15px solid transparent"
                            }`,
                          }}
                          key={index}
                          className="ex-su-maindiv"
                          onClick={() => setIndexSilde(index)}
                        >
                          <div
                            className={`index-dev ${
                              index === indexSilde && "active-index"
                            } `}
                          >
                            {index + 1}
                          </div>
                          {parser(elem)}
                          {index === htmlString.length - 1 && (
                            <div
                              className="
                            absolute 
                            left-1/2 -translate-x-1/2 
                            bottom-[150px]
                            flex flex-col items-center
                            z-50
                          "
                            >
                              <div className="flex flex-col sm:flex-row items-center gap-[20px]">
                                {/* Back Button */}
                                <div className="relative group">
                                  <button
                                    disabled={apiLogin}
                                    onClick={() =>
                                      navigator(PageRoutes.InvestorCenter)
                                    }
                                    className="
                                  flex items-center gap-2 px-8 py-3 rounded-2xl
                                  bg-white text-gray-700 font-semibold shadow-md
                                  border border-gray-200
                                  hover:shadow-lg hover:bg-gray-50
                                  transition-all duration-300
                                "
                                  >
                                    {apiLogin ? (
                                      <Loader2 className="animate-spin w-5 h-5" />
                                    ) : (
                                      <>
                                        <ArrowLeft size={18} />
                                        Back
                                      </>
                                    )}
                                  </button>

                                  {/* Tooltip */}
                                  <div
                                    className="
                                  absolute left-1/2 -translate-x-1/2 -top-10
                                  bg-black text-white text-xs px-3 py-1 rounded-md
                                  opacity-0 group-hover:opacity-100
                                  transition-all duration-300 shadow-md
                                  whitespace-nowrap
                                "
                                  >
                                    Investor landing
                                  </div>
                                </div>

                                {/* Next Button */}
                                <div className="relative group">
                                  <button
                                    disabled={apiLogin}
                                    onClick={() => {
                                      if (
                                        businessObject.message === "ALLOWED"
                                      ) {
                                        navigator(PageRoutes.ExecutiveSummary);
                                        return;
                                      } else if (
                                        !apiLogin &&
                                        (businessObject.message ===
                                          "Learn More About TICCA" ||
                                          businessObject.message === "")
                                      ) {
                                        requestPPM();
                                      }
                                    }}
                                    className="
                                  flex items-center gap-2 px-10 py-3 rounded-2xl
                                  bg-gradient-to-r from-blue-600 to-cyan-400
                                  text-white font-semibold shadow-md
                                  hover:shadow-xl hover:scale-[1.02]
                                  transition-all duration-300
                                "
                                  >
                                    {apiLogin ? (
                                      <Loader2 className="animate-spin w-5 h-5" />
                                    ) : (
                                      <>
                                        {accessDoc["13678"] === "PENDING"
                                          ? "Your request is pending"
                                          : accessDoc["13678"] === "DENIED"
                                            ? "Your request is denied"
                                            : accessDoc["13678"] === "ALLOWED"
                                              ? "Bussiness Summary"
                                              : "Learn More About"}
                                        <ArrowRight size={18} />{" "}
                                      </>
                                    )}
                                  </button>

                                  {/* Tooltip */}
                                  <div
                                    className="
                                  absolute left-1/2 -translate-x-1/2 -top-10
                                  bg-black text-white text-xs px-3 py-1 rounded-md
                                  opacity-0 group-hover:opacity-100
                                  transition-all duration-300 shadow-md
                                  whitespace-nowrap
                                "
                                  >
                                    Bussiness Summary
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            style={{
                              justifyContent: `${
                                index === 0 ? "end" : "space-between"
                              }`,
                            }}
                            className="footer-div"
                          >
                            {index !== 0 && (
                              <img
                                src="https://public.ticca.com/images/svg/TiccaLogo_Null_EmailVerification_WhiteRedOrangeGreen_150X33.svg"
                                alt="logo"
                              />
                            )}
                            <p>Commercial in confidence</p>
                          </div>
                        </div>
                      </Link>
                    </>
                  ))
                ) : (
                  <>
                    {" "}
                    {Array.from({ length: 6 }).map((_, index) => (
                      <>
                        <div
                          style={{
                            marginBottom: "100px",
                            cursor: "pointer",
                            borderRadius: "20PX",
                            border: `${
                              index == indexSilde
                                ? "15px solid rgba(71, 144, 255, 1)"
                                : "15px solid transparent"
                            }`,
                          }}
                          key={index}
                          className="ex-su-maindiv"
                          onClick={() => setIndexSilde(index)}
                        >
                          <div
                            className={`index-dev ${
                              index === indexSilde && "active-index"
                            } `}
                          >
                            {index + 1}
                          </div>
                          <div className="page-shimmer" key={index}></div>
                        </div>
                      </>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
          <div
            style={{ marginTop: "50px" }}
            ref={containerRef}
            className="ex-su-maindiv-sub"
            onContextMenu={handleContextMenu}
          >
            {cmsContentString?.length > 0 ? (
              cmsContentString?.map((elem: string, index: any) => (
                <div key={index} className="ex-su-maindiv">
                  <InView
                    threshold={0.5} // Adjust threshold to 0.5 for testing
                    rootMargin="0% 0% -5% 0%"
                    // delay={500}
                    onChange={(inView) => {
                      if (inView) {
                        setIndexSilde(index);
                      }
                    }}
                  >
                    <div className="watermaring-main-dev">
                      <img
                        src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
                        alt="logo"
                      />
                      <p>
                        Commercial in Confidence <br />
                        Content under NDA.
                        <br /> {userLoginData?.email}
                      </p>
                    </div>
                    <Element name={`bs-${index}`} className={`bs-${index}`}>
                      {parser(elem)}
                      {index === htmlString.length - 1 && (
                        <div
                          className="
                            absolute 
                            left-1/2 -translate-x-1/2 
                            bottom-[150px]
                            flex flex-col items-center
                            z-50
                          "
                        >
                          <div className="flex flex-col sm:flex-row items-center gap-[20px]">
                            {/* Back Button */}
                            <div className="relative group">
                              <button
                                disabled={apiLogin}
                                onClick={() =>
                                  navigator(PageRoutes.InvestorCenter)
                                }
                                className="
                                  flex items-center gap-2 px-8 py-3 rounded-2xl
                                  bg-white text-gray-700 font-semibold shadow-md
                                  border border-gray-200
                                  hover:shadow-lg hover:bg-gray-50
                                  transition-all duration-300
                                "
                              >
                                {apiLogin ? (
                                  <Loader2 className="animate-spin w-5 h-5" />
                                ) : (
                                  <>
                                    <ArrowLeft size={18} />
                                    Back
                                  </>
                                )}
                              </button>

                              {/* Tooltip */}
                              <div
                                className="
                                  absolute left-1/2 -translate-x-1/2 -top-10
                                  bg-black text-white text-xs px-3 py-1 rounded-md
                                  opacity-0 group-hover:opacity-100
                                  transition-all duration-300 shadow-md
                                  whitespace-nowrap
                                "
                              >
                                Investor landing
                              </div>
                            </div>

                            {/* Next Button */}
                            <div className="relative group">
                              <button
                                disabled={apiLogin}
                                onClick={() => {
                                  if (businessObject.message === "ALLOWED") {
                                    navigator(PageRoutes.ExecutiveSummary);
                                    return;
                                  } else if (
                                    !apiLogin &&
                                    (businessObject.message ===
                                      "Learn More About TICCA" ||
                                      businessObject.message === "")
                                  ) {
                                    requestPPM();
                                  }
                                }}
                                className="
                                  flex items-center gap-2 px-10 py-3 rounded-2xl
                                  bg-gradient-to-r from-blue-600 to-cyan-400
                                  text-white font-semibold shadow-md
                                  hover:shadow-xl hover:scale-[1.02]
                                  transition-all duration-300
                                "
                              >
                                {apiLogin ? (
                                  <Loader2 className="animate-spin w-5 h-5" />
                                ) : (
                                  <>
                                    {accessDoc["13678"] === "PENDING"
                                      ? "Your request is pending"
                                      : accessDoc["13678"] === "DENIED"
                                        ? "Your request is denied"
                                        : accessDoc["13678"] === "ALLOWED"
                                          ? "Bussiness Summary"
                                          : "Learn More About"}
                                    <ArrowRight size={18} />{" "}
                                  </>
                                )}
                              </button>

                              {/* Tooltip */}
                              <div
                                className="
                                  absolute left-1/2 -translate-x-1/2 -top-10
                                  bg-black text-white text-xs px-3 py-1 rounded-md
                                  opacity-0 group-hover:opacity-100
                                  transition-all duration-300 shadow-md
                                  whitespace-nowrap
                                "
                              >
                                Bussiness Summary
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Element>
                    <div
                      style={{
                        justifyContent: `${index === 0 ? "end" : "space-between"}`,
                      }}
                      className="footer-div"
                    >
                      {index !== 0 && (
                        <img
                          src="https://public.ticca.com/images/svg/TiccaLogo_Null_EmailVerification_WhiteRedOrangeGreen_150X33.svg"
                          alt="logo"
                        />
                      )}
                      <p>Commercial in confidence</p>
                    </div>
                  </InView>
                </div>
              ))
            ) : (
              <>
                {Array.from({ length: 6 }).map((_, index) => (
                  <div className="page-shimmer" key={index}></div>
                ))}
              </>
            )}
          </div>
    </>
  );
};

export default Intro;
